module.exports = __webpack_public_path__ + "img/logo-guest-group.ccfb0c7e.png";